export default __webpack_public_path__ + "static/media/innovative.465a3eb4.jpeg";